import Vue from 'vue';
import Vuex from 'vuex';
import {json} from 'd3-fetch';

const d3 = {
	json
}

Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {
		data: [],
	},
	getters : {
	},
	mutations: {
		SET_DATA(state, data) {
			state.data = data;
		}
	},
	actions:{
		fetchData({ commit}) {
			return new Promise((resolve, reject) => { 
				
					Promise.all([
						d3.json(`https://data.kro-ncrv.nl/2021/zigeunerrazzia-2/assets/data/story.json`)
					])
					.then(([data]) =>  {
						data.pop();
						commit("SET_DATA", data);
						resolve();
					})
			});
		}
	}
})
